const translations = {
    noFieldsFound: 'No fields found.',
    search: 'Search',
    selectAFarmToSeeFields: 'Please select a farm to see fields.'
};

export default translations;
